import type { FC } from 'react'
import { Box, Spinner } from '@chakra-ui/react'

interface Props {
  absolute?: boolean
  fullPage?: boolean
}

const AmSpinner:FC<Props> = ({ absolute = false, fullPage = false }) => {
  const absStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 15
  }

  const fpStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgb(89 89 89 / 40%)',
    zIndex: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }

  if (fullPage) {
    return (
      <Box sx={fpStyle}>
        <Spinner
          color='brand.main'
          size='3xl'
          thickness='8px'
        />
      </Box>
    )
  }

  return (
    <Spinner
      color='brand.main'
      size='xl'
      thickness='4px'
      mt={absolute ? 0 : 10}
      sx={absolute ? absStyle : {}}
    />
  )
}

export default AmSpinner
